export const PlayerMenuList = [
  //Dashboard
  {
    title: "Main Menu",
    classsChange: "menu-title",
    extraclass: "first",
  },
  {
    title: "Attendance",
    to: "attendance",
    iconStyle: <i className="la la-calendar" />,
  },
  {
    title: "Payment History",
    to: "payment-history",
    iconStyle: <i className="la la-credit-card" />,
  },
];
